export default __webpack_public_path__ + "static/media/kyc.a3564384.svg";